import 'lightslider';
import 'lightgallery';
import 'lg-video';

var $productSlider, $slides, slider;

export function init (settings) {
  $productSlider = $(settings.el);
  $slides = $productSlider.children('li');

  _render(settings);
}

function _render (settings) {
  let slidesCount = $slides.length;

  slider = $productSlider.lightSlider({
    gallery: slidesCount > 1,
    pager: slidesCount > 1,
    controls: slidesCount > 1,
    item: 1,
    loop: false,
    thumbItem: 6,
    adaptiveHeight: true,
    // mode: 'fade',
    enableDrag: false,
    currentPagerPosition: 'left',
    onSliderLoad (el) {
      $productSlider.removeClass('cS-hidden');
      el.lightGallery({
        selector: settings.el + ' .lslide'
      });
    }
  });
}

export function toggle (value) {
  if (slider.length) {
    let $slide = $slides.filter((index, slide) => {
      return $(slide).data('value') == value;
    }).first();

    console.log({ value, $slide, index: $slides.index($slide) });

    slider.goToSlide($slides.index($slide));
  }
}
